import { readonly, ref, Ref } from 'vue'
import CBuffer from 'CBuffer'

export interface CircularBuffer<T> {
  remove: (item: T) => void
  clear: () => void
  items: Readonly<Ref<T[]>>
  push: (...items: T[]) => void
  unshift: (item: T) => void
}

export function useCircularBuffer<T = unknown>(capacity: number): CircularBuffer<T> {
  const buffer = new CBuffer<T>(capacity)
  const itemsRef = ref<T[]>([])

  function update() {
    // Neue Referenz erzeugen, um Reaktivität auszulösen
    itemsRef.value = [...buffer.toArray()]
  }

  function push(...items: T[]) {
    buffer.push(...items)
    update()
  }

  function remove(item: T) {
    const current = buffer.toArray()
    let index = -1

    if (item?.id)
      index = current.findIndex(arrItem => arrItem.id === item.id)
    else
      index = current.indexOf(item)

    if (index === -1) return

    // Entferne Item
    current.splice(index, 1)

    // Leere Buffer & neu befüllen
    buffer.empty()
    current.forEach((entry) => buffer.push(entry))
    update()
  }

  function unshift(item: T) {
    buffer.unshift(item)
    update()
  }

  function clear() {
    buffer.empty()
    update()
  }

  // Initial befüllen
  update()

  return {
    remove,
    clear,
    items: readonly(itemsRef) as Readonly<Ref<T[]>>,
    push,
    unshift
  }
}
